<template>

    <div :class="$mapStep.type=='toPlanRoute' ?  'brt-map-startAndEndMoudule show':'brt-map-startAndEndMoudule'" ref="mapStartAndEndMoudule">

        <!--选点显示-->
        <div class="select-point" v-if="$store.state.mapStore.isShow(moduleState,[0])">

            <div class="box" @click="back">
                <div>
                    <i class="iconfont icon-left-01"></i>
                </div>
            </div>

            <div class="box input"><input v-model="inputValue" :placeholder="selectType == 'start' ? '请点击地图选择起点':'请点击地图选择终点'" readonly/></div>

            <div class="box">

                <Button icon="icon-route" :type="inputValue.length > 0 ?'':'dark'"  size="small" @click.native="setRoutePoint">
                    <span v-if=" selectType == 'start'">设为起点</span>
                    <span v-else>设为终点</span>
                </Button>

            </div>

        </div>


        <!--已选显示-->
        <div class="selected-point" v-if="$store.state.mapStore.isShow(moduleState,[1,2,3])">

            <div class="input-selection" :state="['toPlanRoute'].indexOf($mapStep.type)>-1 ? 2 : 1">

                <div class="box back" @click="back"><i class="iconfont icon-left-01"></i></div>

                <div class="r-box">

                    <div class="input-box">

                         <div class="rail"></div>

                        <div class="start input">
                            <i class="dot"></i>
                            <input v-model="inputStart" @input="searchPoint(inputStart)" @blur="inputBlur"  @focus="inputfocus('start')" :readonly="brtmap.$route.isExit ? true : false" placeholder="请选择起点"/>
                        </div>

                        <div class="keyPoints-box" v-if="keyPointNodeName">
                            {{keyPointNodeName}}
                        </div>

                        <ul v-if="keyPoints.length">
                            <li class="input" v-for="(item,index) in keyPoints">
                                <i class="iconfont icon-cha" @click="deleteKeyPoints(item,index)"></i>
                                <input v-model="item.name" @blur="inputBlur('keyPoint')"  @focus="inputfocus('keyPoint',index)" @input="keyPointsInput(item,index)" placeholder="请添加途径点"/>
                            </li>
                        </ul>

                        <div class="end input">
                            <i class="dot"></i>
                            <input v-model="inputEnd" @input="searchPoint(inputEnd)"  @blur="inputBlur"  @focus="inputfocus('end')" :readonly="brtmap.$route.isExit ? true : false" placeholder="请选择终点"/>
                        </div>

                    </div>

                    <div class="box changePoint" v-if="!brtmap.$route.isExit">
<!--                        <i class="iconfont icon-icon-test" v-if="brtmap.$selecte.startPoint && brtmap.$selecte.endPoint" @click="addKeyPoints"></i>-->
                        <i class="iconfont icon-luxian"  @click="changePoint"></i>
                    </div>

                </div>
            </div>

            <div class="route-routeLineType" v-if="$store.state.mapStore.isShow(moduleState,[1,3]) && brtmap.openVehicle">
                <div class="box" v-for="(item,index) in routeLineType">
                    <div :class="index == routeLineTypeIndex?'wrap active':'wrap'" @click="changeRouteLineType(item,index)" >
                        <i :class="'iconfont icon-'+item.icon"></i>
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>

            <!--<div class="route-selection" v-if="$store.state.mapStore.isShow(moduleState,[1])">-->

                <!--<div class="box" v-for="(item,index) in routeSelect">-->
                    <!--<div :class="index == routeIndex?'wrap active':'wrap'" @click="changeRoute(index,item)" >-->
                        <!--<i :class="'iconfont icon-'+item.icon"></i>-->
                        <!--<span>{{item.name}}</span>-->
                    <!--</div>-->
                <!--</div>-->

            <!--</div>-->

        </div>


        <!--选点显示-->
        <div class="selected-point-content" v-if="$store.state.mapStore.isShow(moduleState,[2])">

            <div class="type-box" v-if="!keyPointsModel">
                <div class="wrap"><a v-for="(item,index) in pointSelect" v-if="item.show" @click="seletPoint(item,'type')"><i :class="'iconfont icon-'+item.icon"></i> <span>{{item.name}}</span></a></div>
            </div>

            <div class="content-box">

                <div class="scroll-box" ref="scroll-box">

                    <div class="serach-box" v-if="serachData.length">
                        <ul>

                            <li v-for="(item,index) in serachData" @click="seletPoint(item,'search')">

                                <div class="l-box"><i class="iconfont icon-marker"></i></div>

                                <div class="r-box">

                                    <p class="title">

                                        <span v-if="item.html" v-html="item.html"></span>

                                        <span v-if="item.FLOOR_NAME">{{item.FLOOR_NAME}}</span>
                                    </p>

                                    <p class="type">
                                        <span v-if="item.distance">{{item.distance}} 米</span>
                                        <span>{{item.CATEGORY_NAME}}</span>
                                        <span v-if="item.REGION">{{item.REGION}}</span>
                                        <span>{{item.buildname}}</span>
                                    </p>

                                </div>

                            </li>

                            <li v-if="toShowHistory && serachData.length" class="clear" @click="histroyData({status:2})">清空历史记录</li>
                        </ul>
                        <FooterLine><!--我是有底线的--></FooterLine>

                    </div>

                    <div class="load-box" v-else-if="searchLoad">
                        <div class="load">
                            <i class="iconfont icon-jiazai11"></i>
                            <i class="iconfont icon-location-2"></i>
                        </div>
                    </div>

                    <div class="empty-box" v-else>
                        搜索结果为空，换个词试试吧！
                    </div>

                </div>
            </div>
        </div>

        <!--添加途径点提示-->
        <div class="keyPoints-fixed-dialog" v-if="keyPointsDialog">
            <div class="wrap">
                <div class="content">
                    您是需要设该点为途径点，<br>
                    并立即规划路线吗?
                </div>

                <div class="btn">
                    <a @click="keyPointsDialog=false">取消</a>
                    <a @click="setKeyPoint">仅设途径点</a>
                    <a @click="setKeyPoint(1)">立即规划</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import Button from '@/components/button/Button.vue'
    import { FooterLine } from '@/components/footerLine'

    let counts = 100,
        searchTime = '',
        searchCount = 300;

    export default {
        name: "SetStartAndEndModule",

        data(){
            return {
                moduleState:1,  //显示选点 或 已选点 3没有起点或终点

                inputValue:'',
                btnType:'dark',
                selectType:'end',     //选点类型（起点或终点）

                inputStart:'',
                inputEnd:'',
                inputType:'start',

                searchKey:null,

                searchLoad:false,       //加载动画

                endPlanRoute:false,    //这边进入规划

                routeIndex:0,
                routeSelect:[
                    {
                        name:'距离最短',
                        icon:'juli',
                        ignor:[],
                    },
                    {
                        name:'直梯',
                        icon:'elevator-02',
                        ignor:['150012','150014'],
                    },
                    {
                        name:'扶梯',
                        icon:'elevator-01',
                        ignor:['150012','150013'],
                    },
                    {
                        name:'楼道',
                        icon:'elevator-03',
                        ignor:['150013','150014'],
                    }
                ],

                routeLineTypeIndex:0,

                routeLineType:[
                    {
                        name:'步行',
                        icon:'walk',
                    },
                    {
                        name:'车行',
                        icon:'cheliangguanli',
                    }
                ],

                pointSelectHide:false,
                pointSelect:[
                    {
                        name:'我的位置',
                        icon:'location',
                        type:'location',
                        show:true
                    },
                    {
                        name:'收藏/足迹',
                        icon:'footprint-o',
                        type:'foot',
                        show:this.$mapFunManger.collectAndFoots
                    },
                    {
                        name:'地图选点',
                        icon:'map',
                        type:'map',
                        show:true
                    }
                ],



                serachData:[],
                searchLists:[],
                addStatus:false,

                $start:null,
                $end:null,

                $lastStart:null,
                $lastEnd:null,


                keyPoint:{},    //中转点
                keyPoints:[],   //途径点列表
                keyPointsModel:false,   //途径点选点模式
                keyPointsDialog:false,  //途径点弹框
                keyPointNodeName:'',
                toShowHistory:false,
            }
        },

        components:{
            Button,
            FooterLine,
        },


        created(){

            //控制路径悬着方式显示
            this.bus.$off('routeTypeHide');
            this.bus.$on('routeTypeHide',(res)=>{

                if(res.status == 1){
                    this.moduleState = 3;
                }else{
                    this.moduleState = 1;
                }

            })

            //车行人行显示
            this.bus.$off('routeVehicleHide');
            this.bus.$on('routeVehicleHide',(res)=>{
               this.routeLineTypeIndex = res;
            })

            //触发多途径点删除
            this.bus.$off('keyPointDelete');
            this.bus.$on('keyPointDelete',index=>{
                this.keyPoints.splice(index,1);
                this.routekeyPonts(this.keyPoints,()=>{
                    this.bus.$emit('startAndEnd',{type:0});
                })
            })

        },

        methods:{

            back(){

                let $currenStep = this.$mapStep.type,
                    $lastStep = window.sessionStorage.getItem('lastStep'),
                    $enterType = this.$BRT.$route.enterType;


                let _callback = (n)=>{

                    //途径点处理
                    this.keyPointsModel = false;

                    if(!n || n===1){
                        this.keyPoints=[];
                        this.routekeyPonts(this.keyPoints)
                    }

                    switch (n) {

                        case 0:

                            //从其他页面进入

                            //移除人行规划控制
                            this.moduleState = 0;
                            this.$BRT.$route.vehicleRoute = 0;

                            //关闭逃生通道
                            this.$BRT.$route.isExit = '';
                            this.$BRT.$route.isExitPoint = '';

                            //还原默认车行方式
                            this.$BRT.$CAR_FIRST = this.$BRT.$CAR_BASE_FIRST;

                            //关闭分配空车位
                            this.$BRT.parkNoInfo = '';

                            if($enterType == 'poiDetail'){  //详情进入

                                this.bus.$emit('selectedPoint',this.$mapStep.poiID);
                                this.$mapStep.type='poiDetail';

                            }
                            else{

                                this.$router.replace(this.$BRT.lastRoute);
                                this.$mapStep.type = '';

                            }

                            this.$BRT.$route.enterType='';

                            this.$BRT.$route.ignore = [];

                            //移除数据
                            this.$BRT.$selecte.startPoint = '';
                            this.$BRT.$selecte.endPoint = '';
                            this.bus.$emit('startAndEnd',{type:0});

                            break;

                        case 1:

                            //选点页面进入

                            //移除人行规划控制
                            this.moduleState = 0;
                            this.$BRT.$route.vehicleRoute = 0;

                            //关闭逃生通道
                            this.$BRT.$route.isExit = false;
                            this.$BRT.$route.isExitPoint = '';

                            //清理进入状态
                            this.endPlanRoute=false;

                            //移除数据
                            this.$BRT.$selecte.startPoint = '';
                            this.$BRT.$selecte.endPoint = '';
                            this.bus.$emit('startAndEnd',{type:0});
                            this.$BRT.$route.ignore = [];

                            //还原默认车行方式
                            this.$BRT.$CAR_FIRST = this.$BRT.$CAR_BASE_FIRST;

                            //显示进入规划的点位
                            let $poi = this.$mapStep.poiID;

                            if($poi){
                                this.$mapStep.poiID=$poi;
                                this.bus.$emit('selectedPoint',this.$mapStep.poiID);
                                this.$mapStep.type = 'selectePOI';
                            }

                            else{
                                this.$mapStep.type = '';
                            }

                            break;

                        case 2:
                            //规划页面
                            //软盘影响布局待解决(返回规划页面)
                            this.$mapStep.type = 'planRoute';
                            this.moduleState =1;

                            //移除为空的途径点
                            this.keyPoints = this.keyPoints.filter(item=>{
                                return !!item.name && !!item.point;
                            })

                            this.routekeyPonts(this.keyPoints)


                            if(!this.$lastStart && !this.$lastEnd && !this.$start && !this.$end){   //没干啥就返回
                                this.bus.$emit('startAndEnd',{type:0});
                                return;
                            }


                            if(this.inputType == 'start'){

                                this.$BRT.$selecte.startPoint=this.$lastStart ? this.$lastStart : (this.$start ? this.$start : '');
                                this.$BRT.$selecte.endPoint =this.$lastEnd ? this.$lastEnd : (this.$end ? this.$end : '');

                                this.bus.$emit('startAndEnd',{type:0});//有值

                            }
                            else{

                                this.$BRT.$selecte.startPoint=this.$lastStart ? this.$lastStart : (this.$start ? this.$start : '');
                                this.$BRT.$selecte.endPoint =this.$lastEnd ? this.$lastEnd : (this.$end ? this.$end : '');
                                this.bus.$emit('startAndEnd',{type:0});//有值

                            }

                            this.$start = '';
                            this.$end = '';
                            this.$lastEnd= '';
                            this.$lastEnd= '';


                            //如果有一个值为空，则清空途经点
                            if(!this.$BRT.$selecte.startPoint || !this.$BRT.$selecte.endPoint){
                                this.keyPoints = [];
                                this.routekeyPonts(this.keyPoints)
                            }


                            if(this.$BRT.$selecte.startPoint){
                                this.inputStart = this.setPoint(this.$BRT.$selecte.startPoint)
                            }

                            this.$BRT.$route.selectType.type = '';

                            if(this.$BRT.$selecte.endPoint){
                                this.inputEnd = this.setPoint(this.$BRT.$selecte.endPoint)
                            }

                            break;

                        case 3:
                            //去规划
                            //移除人行规划控制
                            this.moduleState = 0;
                            this.$BRT.$route.vehicleRoute = 0;

                            this.endPlanRoute =false;
                            this.$mapStep.type = 'toPlanRoute';

                            if(this.$BRT.$route.selectType == 'map'){
                                this.$BRT.$route.selectType = '';
                            }


                            this.$BRT.$selecte.startPoint=this.$start ? this.$start : this.$BRT.$selecte.startPoint;
                            this.$BRT.$selecte.endPoint =this.$end ? this.$end : this.$BRT.$selecte.endPoint;

                            // 搜索状态
                            // this.serachData = [];
                            // this.searchKey ? this.searchPoint(this.searchKey):'';

                            if(this.$BRT.$selecte.startPoint){
                                this.inputStart = this.setPoint(this.$BRT.$selecte.startPoint)
                            }

                            if(this.$BRT.$selecte.endPoint){
                                this.inputEnd = this.setPoint(this.$BRT.$selecte.endPoint)
                            }

                            this.moduleState =2;
                            break;

                        default:break
                    }

                }

                // console.log('this.endPlanRoute',this.endPlanRoute,'$lastStep',$lastStep,'$currenStep',$currenStep,'$enterType',$enterType);

                if(this.endPlanRoute){

                    if($currenStep == 'toPlanRoute'){

                        _callback(2)
                    }else{
                        let start = this.brtmap.$selecte.startPoint,
                            end = this.brtmap.$selecte.endPoint;

                        if(this.brtmap.$route.selectType.type != 'map' && ($lastStep == 'selectePOI' || ($lastStep=='toPlanRoute' && (!start || !end))) ){
                            _callback(1);
                        }else{
                            _callback(3);
                        }

                    }
                }

                else{

                    if( ['search','findCar','mainActive','poiDetail','parkingEnter'].indexOf($enterType) > -1 ){
                        //从其他页面进入
                        _callback(0);
                    }

                    else if(!$lastStep || ['selectePOI','toPlanRoute','toNAVING'].indexOf($lastStep) > -1 ){

                        if($currenStep == 'planRoute'){
                            if(this.$BRT.$route.selectType == 'map'){
                                _callback(3);
                            }else{
                                _callback(1);
                            }

                        }else{
                            _callback(2)
                        }

                    }

                    else if($currenStep == 'toPlanRoute'){
                        _callback(2);

                    }else{

                        _callback(3);

                    }

                }

            },

            setPoint(point){

                if(point){
                    let $name = ''; //point ? (point.x && point.y ? "我的位置" : (point.NAME ? point.NAME : '无名地址') ) : ''

                    if(point){
                        $name = point.NAME || '无名地址';
                        if(!point.NAME && (point.x && point.y))$name = '我的位置';
                    }

                    let $floor = '';
                    //添加楼层
                    if(point.FLOOR_NAME || point.floorName){
                        $floor =  point.FLOOR_NAME ? point.FLOOR_NAME : point.floorName

                    }

                    else if(point.x && point.y){

                        $floor =  $VAR.map.getFloorInfoByIndex(point.floor).floorName
                    }

                    if(!this.$BRT.insertMap && $name=='我的位置'){
                        return $name;
                    }else{
                        return $name + ' ' + $floor;
                    }

                }

                return null;
            },

            setRoutePoint(){
                let $brtmap=this.$store.state.mapStore.brtmap;

                if($brtmap.$route.selectType.pointType == 'start'){

                    if($brtmap.$selecte.endPoint && $brtmap.$selecte.endPoint.NAME=="我的位置"){

                        $brtmap.$selecte.endPoint  = JSON.parse(JSON.stringify($brtmap.$locate.point));

                        if($brtmap.$selecte.endPoint){
                            $brtmap.$selecte.endPoint.NAME='我的位置'
                        }

                    }

                    $brtmap.$selecte.startPoint = $brtmap.$route.selectType.point;

                }else{

                    //设为终点（若起点会我的位置，同步更改点位）
                    if($brtmap.$selecte.startPoint && $brtmap.$selecte.startPoint.NAME=="我的位置"){

                        $brtmap.$selecte.startPoint = JSON.parse(JSON.stringify($brtmap.$locate.point));

                        if($brtmap.$selecte.startPoint){
                            $brtmap.$selecte.startPoint.NAME='我的位置'
                        }

                    }


                    $brtmap.$selecte.endPoint = $brtmap.$route.selectType.point;
                }


                this.bus.$emit('startAndEnd',{type:0});

                this.moduleState = 1;

            },

            changePoint(){  //交换起终点

                let $brtmap=this.$store.state.mapStore.brtmap,
                    tem=$brtmap.$selecte.startPoint;

                $brtmap.$selecte.startPoint = $brtmap.$selecte.endPoint;

                $brtmap.$selecte.endPoint = tem;

                //我的位置，同步更改点位
                if($brtmap.$locate.point){

                    if($brtmap.$selecte.startPoint && $brtmap.$selecte.startPoint.NAME=="我的位置"){
                        $brtmap.$selecte.startPoint = JSON.parse(JSON.stringify($brtmap.$locate.point));

                        if($brtmap.$selecte.startPoint){
                            $brtmap.$selecte.startPoint.NAME='我的位置'
                        }
                    }

                    if($brtmap.$selecte.endPoint && $brtmap.$selecte.endPoint.NAME=="我的位置"){

                        $brtmap.$selecte.endPoint = JSON.parse(JSON.stringify($brtmap.$locate.point));

                        if($brtmap.$selecte.endPoint){
                            $brtmap.$selecte.endPoint.NAME='我的位置'
                        }
                    }

                }

                //上一步保存数据更改
                this.$start = $brtmap.$selecte.startPoint;
                this.$end = $brtmap.$selecte.endPoint;


                this.bus.$emit('startAndEnd',{type:0});
            },

            changeRoute(index,item){
                this.routeIndex = index;
                this.$store.state.mapStore.brtmap.$route.ignore = item.ignor;
            },

            inputfocus(type,index){   //聚焦

                if(!this.brtmap.$route.isExit){

                    this.endPlanRoute = true;

                    if(type == 'keyPoint'){

                        this.$mapStep.type = 'toPlanRoute';
                        this.moduleState = 2;

                        //初始化历史记录
                        this.serachData = [];
                        this.histroyData({status:1});

                        //this.pointSelectHide = true;
                        this.keyPointsModel =  true;

                        //记录index
                        this.keyPoint = Object.assign({},{index:index})


                    }

                    else {

                        this.inputType = type;
                        this.$mapStep.type = 'toPlanRoute';
                        this.moduleState = 2;

                        this.keyPoint = {};
                        this.keyPointsModel =  false;

                        if(!this.inputStart || !this.inputEnd){
                            //初始化历史记录
                            this.serachData = [];
                            this.histroyData({status:1})
                        }

                    }

                }

            },

            inputBlur(type){ //移除焦点

                if(type == 'keyPoint'){
                    //this.pointSelectHide = false;
                }

            },

            dealserach(res,value){

                this.serachData = [];

                let $data= [];

                for(let i=0;i<res.length;i++){

                    let r = res[i];

                    r.buildname = $VAR.map.building.name;

                    if(r.NAME){
                        r.html = r.NAME.replace(value,`<font>${value}</font>`);

                        if(this.brtmap.$locate.point){
                            this.bus.$emit('getDistant',{
                                type:1,
                                point:r,
                                callback:(data)=>{
                                    r.distance = data ? data.distance : 0;
                                }
                            });
                        }

                        $data.push(r);
                    }

                }

                //根据距离排序
                if($data.length > 1 && this.brtmap.$locate.point){
                    $data = $data.sort((v1,v2)=>{
                        return v1.distance - v2.distance;
                    })
                }

                this.searchLoad = false;
                if($data.length >0){

                    this.searchLists = $data;

                    if($data.length > counts){
                        this.addStatus = true;
                        this.serachData = $data.slice(0,counts);
                    }
                    else{
                        this.serachData = $data;
                    }
                }

            },

            searchPoint(value){


                if(!value){
                    this.histroyData({status:1});
                    return;
                }

                let $this =this;
                this.toShowHistory = false;

                $this.serachData=[];
                value =value.trim();

                //先清除
                clearTimeout(searchTime);
                searchTime = '';
                this.searchLoad = true;

                searchTime = setTimeout(()=>{

                    if(value){

                        //地图搜索使用
                        $VAR.brtmapSearch.query({
                                type:'name',
                                value:value

                            },
                            function (result) {

                                $this.searchKey = value;

                                let _data = [];

                                //大类处理
                                for(let i=0;i<result.length;i++){

                                    if(result[i].children){

                                        for(let j=0;j<result[i].children.length;j++){

                                            if(result[i].children[j].children){

                                                _data = _data.concat(result[i].children[j].children)

                                            }else{
                                                _data.push(result[i].children[j])
                                            }

                                        }

                                    }else{

                                        _data.push(result[i])
                                    }

                                }

                                $this.dealserach(_data,value);
                            });

                    }
                    else {
                        this.serachData=[];
                    }

                },searchCount)
            },

            histroyData(res){

                //保存为历史纪录
                let $historyNAME = $VAR.map.building.buildingID + '_RouteHistory',

                    $historyData = window.localStorage.getItem($historyNAME);

                $historyData = !!($historyData) ? JSON.parse($historyData) : [];

                if(res.status == 1){//初始

                    this.serachData = $historyData;

                    this.toShowHistory = true;

                }

                else if(res.status == 2){//清空
                    window.localStorage.setItem($historyNAME,'');
                    this.serachData = [];
                    this.toShowHistory = false;
                }

                else{//储存及替换

                    //判断是否存在 POI_ID
                    $historyData.map((item,index)=>{
                        if(item.POI_ID == res.item.POI_ID){$historyData.splice(index,1)}
                    })

                    res.item.html =  res.item.NAME;
                    res.item.distance = 0;
                    $historyData.unshift(res.item);
                    window.localStorage.setItem($historyNAME,JSON.stringify($historyData))
                }

            },

            seletPoint(item,type){


                let $brtmap = this.$BRT;

                if(this.keyPointsModel){


                    if($brtmap.$selecte.startPoint && $brtmap.$selecte.startPoint.POI_ID){
                        if(item.POI_ID ==  $brtmap.$selecte.startPoint.POI_ID){
                            this.$message.info('途径点不能与起点相同');
                            return;
                        }
                    }
                    if($brtmap.$selecte.endPoint && $brtmap.$selecte.endPoint.POI_ID){
                        if(item.POI_ID ==  $brtmap.$selecte.endPoint.POI_ID){
                            this.$message.info('途径点不能与终点相同');
                            return;
                        }
                    }

                    if(this.keyPoints.some(child=>{
                        if(child.point){
                            return child.point.POI_ID == item.POI_ID
                        }
                        return false;
                    })){
                        this.$message.info('已存在该途径点');
                        return;
                    }

                    //添加途径点
                    this.keyPoint = Object.assign({},this.keyPoint,{point:item});

                    //保存历史足迹
                    this.histroyData({item:item});

                    //显示历史记录
                    this.histroyData({status:1})

                    this.keyPointsDialog = true;



                }

                else{
                    //防止回退(只保留两步)
                    this.$lastStart = JSON.parse(JSON.stringify(this.$start));
                    this.$lastEnd = JSON.parse(JSON.stringify(this.$end));
                    this.$start =JSON.parse(JSON.stringify($brtmap.$selecte.startPoint));
                    this.$end = JSON.parse(JSON.stringify($brtmap.$selecte.endPoint));

                    if(type == 'search'){

                        this.histroyData({item:item})

                        //路径规划需要
                        item.floor = item.FLOOR_NUMBER;

                        //是否需要改变楼层
                        if(item.floor != $VAR.map.currentMapInfo.floorNumber){
                            let $zoom = $VAR.map.getZoom();
                            $VAR.map.setFloor(item.FLOOR_ID,()=>{
                                $VAR.map.stop().easeTo({
                                    zoom:$zoom
                                })
                            });
                        }


                        this.$mapStep.type = 'planRoute';
                        this.moduleState =1;

                        if(this.inputType == "start"){

                            $brtmap.$selecte.startPoint = item
                            this.bus.$emit('startAndEnd',{type:0});

                        }else{

                            $brtmap.$selecte.endPoint = item;
                            this.bus.$emit('startAndEnd',{type:0});

                        }

                        //显示历史记录
                        this.histroyData({status:1})

                        //重新搜索
                        // setTimeout(()=>{this.searchPoint(item.NAME)},0)

                    }

                    else{

                        if(item.type == 'location'){

                            // 方式选点
                            this.inputType == "start" ?  $brtmap.$selecte.startPoint = '' : $brtmap.$selecte.endPoint='';

                            //定位选点
                            this.moduleState =1;
                            this.$BRT.$route.route =null;
                            $VAR.map.resetRoute(); //移除路径
                            this.inputType == "start" ? this.$BRT.$marker.start.empty() : this.$BRT.$marker.end.empty();
                            this.selectType = this.inputType;
                            this.$mapStep.type = 'planRoute';
                            $brtmap.$locate.point = '';   //开启定位


                        }

                        else if(item.type == 'map'){   //地图选点

                            // 方式选点
                            this.inputType == "start" ?  $brtmap.$selecte.startPoint = '' : $brtmap.$selecte.endPoint='';

                            this.moduleState =0;
                            this.inputValue = '';
                            this.$BRT.$route.route =null;
                            $VAR.map.resetRoute(); //移除路径

                            this.inputType == "start" ? this.$BRT.$marker.start.empty() : this.$BRT.$marker.end.empty();

                            this.selectType = this.inputType;
                            this.$mapStep.type = 'planRoute';


                        }

                        else{  //收藏/足迹

                            this.endPlanRoute=false;

                            if(this.$mapFunManger.collectAndFoots === 2){
                                if(this.$mapFunManger.needLogin && !this.$mapStore.plugInfo.phone){
                                    this.$message.info('请先登录');
                                    this.bus.$emit('LoginCallback',{status:1});
                                    return;
                                }
                            }

                            this.$BRT.$options.Footprint = true;
                            this.$BRT.$options.FootprintTabIndex =1;

                        }

                        $brtmap.$route.selectType = {type:item.type,pointType:this.inputType,point:null};

                    }

                }

            },

            changeRouteLineType(item,index){

                this.routeLineTypeIndex = index;

                if(!index){
                    this.brtmap.existVehicle = false;
                    this.brtmap.$route.vehicle = false; //关闭车行
                    this.brtmap.$route.vehicleRoute = 1;
                }else{
                    this.brtmap.$route.vehicleRoute = 0;
                    this.brtmap.existVehicle = true;
                    this.brtmap.$route.vehicle = true;  //开启车行
                }

                this.bus.$emit('startAndEnd',{type:0});
            },

            addKeyPoints(){

                if(this.$mapStep.type === 'planRoute'){

                    let $index = 0,
                        isTrue = this.keyPoints.some((item,index)=>{
                            if(!item.name)$index = index;
                            return !item.name
                        });

                    if(isTrue){

                        this.inputfocus('keyPoint',$index);

                    }else{

                        // this.keyPoints.push({
                        //     name:'',
                        //     point:''
                        // });

                        this.inputfocus('keyPoint',0);
                    }

                    return;
                }

                if(!this.brtmap.$selecte.startPoint || !this.brtmap.$selecte.endPoint){
                    this.$message.info('起终点同时存在才允许添加');
                    return;
                }


                if(this.keyPoints.length){
                    if(this.keyPoints.some(item=>{return !item.name})){
                        this.$message.info('存在途径点为空');
                        return;
                    }
                }



                //开启途径点模式
                this.keyPointsModel = true;

                //清楚筛选,显示历史记录
                this.histroyData({status:1})

                this.keyPoints.push({
                    name:'',
                    point:''
                })
            },

            deleteKeyPoints(item,index){
                this.keyPoints.splice(index,1);
                this.routekeyPonts(this.keyPoints);
                this.keyPointsModel = false;
            },

            keyPointsInput(item,index){
                //记录index
                this.keyPoint = Object.assign({},{index:index})
                if(item.name)this.searchPoint(item.name);
            },

            setKeyPoint(type){


                let index = this.keyPoint.index,
                    keyPoint = {
                    name:this.keyPoint.point.NAME + '' + this.keyPoint.point.FLOOR_NAME,
                    point:this.keyPoint.point
                }

                if(index){
                    this.keyPoints.splice(index,1,keyPoint)
                }else{
                    this.keyPoints.splice(0,1,keyPoint)
                }

                this.keyPointsModel = false;
                this.keyPointsDialog = false;

                this.routekeyPonts(this.keyPoints,()=>{

                    if(type === 1){
                        //立刻规划
                        this.$mapStep.type = 'planRoute';
                        this.moduleState =1;
                        this.bus.$emit('startAndEnd',{type:0});
                    }

                })


            },

            routekeyPonts(data,callback){

                this.brtmap.$route.keyPoints.map(item=>{
                    if(item.marker){
                        item.marker.empty()
                    }
                })

                this.brtmap.$route.keyPoints = data.concat();

                let nodeName = '';
                data.map(item=>{
                    if(item.name){
                        nodeName += item.name + '、'
                    }
                })

                this.keyPointNodeName = nodeName.slice(0,nodeName.length - 1);

                callback && callback();

            }
        },

        watch:{

            moduleState(v1){

                if(v1==2){

                    this.$nextTick(()=>{

                        this.$refs['scroll-box'].addEventListener('scroll',e=>{

                            let el = e.target,
                                rs = this.searchLists,
                                ls = this.serachData,
                                as = this.addStatus;

                            if(this.moduleState === 2 && rs.length){

                                if(el.scrollHeight - el.scrollTop - el.clientHeight < 100){

                                    if(ls.length && as && rs.length > ls.length){

                                        this.addStatus = false;

                                        if(rs.length - ls.length > counts){

                                            this.serachData = ls.concat(rs.slice(ls.length,ls.length+counts));

                                            this.$nextTick(()=>{
                                                this.addStatus = true;
                                            })

                                        }
                                        else{
                                            this.serachData = ls.concat(rs.slice(ls.length,rs.length));
                                        }

                                    }

                                }

                            }
                        })
                    })
                }

            },

            start(v1,v2){

                v1 ? this.inputStart = this.setPoint(v1):this.inputStart= '';

                //历史足迹选点
                if(this.$BRT.$route.selectType.type == 'foot'){
                    this.endPlanRoute = v1 ? true:false
                }

            },

            end(v1,v2){

                v1 ? this.inputEnd = this.setPoint(v1):this.inputEnd='';

                //历史足迹选点
                if(this.$BRT.$route.selectType.type == 'foot'){
                    this.endPlanRoute = v1 ? true:false
                }

            },

            selectPoi(v1,v2){


                let $this=this, $brtmap =$this.$store.state.mapStore.brtmap;

                if(v2 && v1 && v1.POI_ID && v2 == v1.POI_ID)return;


                // console.log(v1,v2);

                if(v1){

                    if((v1.x && v1.y) || (v1.LABEL_X && v1.LABEL_Y)){   //定位或poi信息

                        $brtmap.$route.selectType.pointType == 'start' ? $brtmap.$selecte.startPoint = v1 : $brtmap.$selecte.endPoint = v1;

                    }else{  //地图选点 poiID

                        //根据poi查询poi信息
                        $VAR.brtmapSearch.query({
                            type:'poiid',
                            value:v1
                        }, function (result) {


                            result = result.filter((item,index,self)=>{
                                return item.POI_ID == v1
                            })

                            $this.inputValue = $this.setPoint(result[0]);
                            $brtmap.$route.selectType.point = result[0];

                            //插选点坐标
                            let lnglat = $VAR.map.coordsToLnglat(result[0].LABEL_X,result[0].LABEL_Y),
                                $name=result[0].NAME ? result[0].NAME:'无名地址',
                                $content ='<div class="wrap">' +
                                    '<div class="border"></div>' +
                                    '<div class="bg"></div>' +
                                    '<i></i>' +
                                    '</div>'+
                                    '<div class="tip"><i></i> <div class="txt">'+ $name + '  '+ result[0].FLOOR_NAME +'</div></div>'

                            $this.inputType == "start" ? $brtmap.$marker.start.setContent($content).addClass('showTip').setLnglat(lnglat,result[0].FLOOR_ID) : $brtmap.$marker.end.setContent($content).addClass('showTip').setLnglat(lnglat,result[0].FLOOR_ID)

                        });

                    }

                }
            },

            mapStep(v1,v2){

                if(v1 == 'planRoute' && this.$BRT.$route.selectType.type !='map'){
                    this.moduleState = 1;
                }else if(v1 == 'toPlanRoute'){
                    this.histroyData({status:1});
                }

            },

            ignore(v1,v2){

                if(v1.length == 0){

                    this.routeIndex = 0;

                }else{

                    let str = v1[0] + v1[1];

                    this.routeSelect.map((item,index)=>{

                        if(item.ignor.length > 0){

                            if(item.ignor[0] + item.ignor[1] == str){

                                this.routeIndex = index;

                            }

                        }

                    })


                }

            }

        },

        computed:{

            start(){
                return this.$store.state.mapStore.brtmap.$selecte.startPoint
            },

            end(){
                return this.$store.state.mapStore.brtmap.$selecte.endPoint
            },

            selectPoi(){    //选点定位监听
                return this.$store.state.mapStore.brtmap.$route.selectType.point;
            },

            mapStep(){
                return this.$mapStep.type;
            },

            ignore(){
                return this.$BRT.$route.ignore;
            },

            ...mapState({
                brtmap:state=>state.mapStore.brtmap
            })

        },

        mounted(){

            let $brtmap =this.$store.state.mapStore.brtmap;

            this.inputStart = this.setPoint($brtmap.$selecte.startPoint);
            this.inputEnd =    this.setPoint($brtmap.$selecte.endPoint);

            this.$start =$brtmap.$selecte.startPoint ?  JSON.parse(JSON.stringify($brtmap.$selecte.startPoint)):'';
            this.$end = $brtmap.$selecte.endPoint ? JSON.parse(JSON.stringify($brtmap.$selecte.endPoint)):'';


        },
    }
</script>

<style lang="less">
@import "StartAndEndModule.less";
</style>
